common.View.create('habitats.website.content.items.partials.gate.Form', {

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad()
	{
		// Init Ajax?
		if(this.element.attr('data-ajax') === 1)
			this.initAjax();
	},

	initAjax()
	{
		this.element

			// Listen for form submit?
			.find('form')
				.submit(() => this.onFormSubmitAjax())
				.end();
	},

	onFormSubmitAjax()
	{
		// Make sure we can avoid submitting in the next line.
		setTimeout(() => this.sendFormAjax(), 1);

		// Avoid submitting.
		return false;
	},

	async sendFormAjax()
	{
		// Get form data.
		let form = this.element.find('form');

		let formData = form.serialize();

		//
		this.setFormLoading();

		// Submit
		let response = await $.ajax({
			url: form.attr('action'),
			method: 'post',
			data: formData,
			dataType: 'html',
		});

		// Get new form.
		let element = $('<div></div>').append($.parseHTML(response)).find(this._cssNs());

		// Show validation errors?
		if(element.find('form').length)
			this.showValidationErrorsAjax(element);

		// TODO Medium: Validate response. Is it truly ungated now?
		// Unlock gate?
		else
			this.unlockGateAjax();
	},

	setFormLoading()
	{
		this.element

			// Disable form.
			.find('input, button, select, textarea')
				.attr('disabled', true)
			.end()

			// Show loading.
			.find('button')
				.html('<i class="fas fa-circle-notch fa-spin tw-text-xl"></i>')
				.end();
	},

	showValidationErrorsAjax(element)
	{
		// Replace entire DOM element.
		this.element.replaceWith(element);

		this.element = element;

		// Wait for DOM loaded again.
		setTimeout(() => this.onDOMLoad(), 1);
	},

	unlockGateAjax()
	{
		//
		$(this)
			.trigger('gateUnlocked');
	},

});